import type { FreeBetAmounts, TFreeBetAmount } from 'interfaces/bet-data';
import { EBetslipBetType, EBetslipType } from 'interfaces/betslip';
import { GENERAL_FIELD_KEY } from 'newelements/_Betslip/utils/constants/shared';
import type { IBetslipFreeBetSliceInitial } from 'store/reducers/betslip/freeBet';

type TGetFreeBetAmountsUtil = (
  betslipType: EBetslipType,
  betType: EBetslipBetType,
  freeBetStore: IBetslipFreeBetSliceInitial['freeBets']
) => FreeBetAmounts;

export const getFreeBetAmountsUtil: TGetFreeBetAmountsUtil = (
  betslipType,
  betType,
  freeBetStore
) => {
  if (betslipType === EBetslipType.BASIC) {
    switch (betType) {
      case EBetslipBetType.SINGLE:
        if (freeBetStore.selectedFreeBetEventId) {
          return freeBetStore.singleEventFreeBets[
            freeBetStore.selectedFreeBetEventId
          ];
        }

        break;
      case EBetslipBetType.CHAIN:
      case EBetslipBetType.MULTIPLE:
        return freeBetStore.multipleFreeBets;
    }
  } else {
    if (freeBetStore.selectedFreeBetEventId === GENERAL_FIELD_KEY) {
      return freeBetStore.advancedFreeBets;
    }

    if (freeBetStore.selectedFreeBetEventId) {
      return freeBetStore.singleEventFreeBets[
        freeBetStore.selectedFreeBetEventId
      ];
    }
  }

  return [];
};

type TGetSelectedFreeBetAmountUtil = (
  freeBetAmounts: FreeBetAmounts,
  freeBetStore: IBetslipFreeBetSliceInitial['freeBets']
) => TFreeBetAmount['label'] | undefined;

export const getSelectedFreeBetAmountUtil: TGetSelectedFreeBetAmountUtil = (
  freeBetAmounts,
  freeBets
) => {
  if (!!freeBets.selectedFreeBetEventId && freeBetAmounts) {
    return (
      freeBetAmounts.find(
        (freeBetAmount: { value: number }) =>
          Number(freeBetAmount.value) === Number(freeBets.selectedFreeBetId)
      )?.label || freeBetAmounts[0]?.label
    );
  }
};
